import { createAction } from '@wix/communities-blog-client-common';
import { parseInstance } from './parse-instance';

export const SET_INSTANCE_VALUES = 'instanceValues/SET';

export const setInstanceValues = createAction(SET_INSTANCE_VALUES);

export const initializeInstanceValues = (instance) => (dispatch) =>
  dispatch(setInstanceValues(parseInstance(instance)));
